module.exports = __webpack_public_path__ + "components/star-rating/static/yellow/2-0716b17ae9a2e4c95a1911fd21a241ab.svg";